/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2680__part-0
 */

"use strict"

import * as /* [auto-meaningful-name] */Module_35 from /* 35 */"../35"
import * as /* [auto-meaningful-name] */Module_19 from /* 19 */"../19"
import /* 0 */"react"
import * as /* [auto-meaningful-name] */Module_1542 from /* 1542 */"./1542"
import * as /* [auto-meaningful-name] */Classnames from /* 8 */"classnames"
import /* [auto-meaningful-name] */Classnames1 from /* 8 */"classnames"
import * as /* [auto-meaningful-name] */Module_803 from /* 803 */"../803"
import * as /* [auto-meaningful-name] */Module_615 from /* 615 */"./615"
import * as /* [auto-meaningful-name] */Module_616 from /* 616 */"../616/index"
import * as /* [auto-meaningful-name] */Module_802 from /* 802 */"../616/802"
import * as /* [auto-meaningful-name] */Module_694 from /* 694 */"../801/694/index"
import * as /* [auto-meaningful-name] */Module_801 from /* 801 */"../801/index"
import * as /* [auto-meaningful-name] */Module_466 from /* 466 */"./466"
var g = function () {
  return Module_466.a() && window.document.documentElement
}
export { g }
